




































import {Vue, Component, Prop} from 'vue-property-decorator'
import {ReservationResponse} from '@/lib/kepler/interfaces'
import DateHelper from '@/lib/DateHelper'
import Utils from '@/utils'
import CustomIcon from '@/components/CustomIcon.vue'
import VuetifyColorHelper from '@/lib/vuetify/VuetifyColorHelper'
import moment from 'moment'
import Card from '@/components/proxy/Card/Card.vue'
import GradientCard from '@/components/GradientCard.vue'
import Plate from '@/components/Plate.vue'
import Container from '@/components/proxy/Container.vue'

@Component({
  components: {
    Container,
    Plate,
    GradientCard,
    Card,
    CustomIcon,
    Layout: Utils.loadComponent('proxy/Layout'),
    CardButton: Utils.loadComponent('CardButton'),
  },
  name: 'LightModeCardReservation',
})
export default class LightModeCardReservation extends Vue {
  @Prop() protected reservation!: ReservationResponse
  @Prop() protected future!: boolean
  @Prop() protected showDriver!: boolean
  @Prop({
    type: Boolean,
    default: false,
  }) protected animated!: boolean

  protected getTime(r: ReservationResponse) {
    return DateHelper.formatTimeOffset('dhm', r.end_timestamp - r.start_timestamp)
  }

  protected getDate(isStart: boolean) {
    const start = this.reservation.start
    const end = this.reservation.end
    const now = moment().toISOString()

    function isSameDay(date1: string, date2: string) {
      return moment(date1).isSame(moment(date2), 'day')
    }

    if (start && end) {
      const timestamp = isStart ? start : end
      const m = moment(timestamp)
      if (isSameDay(now, timestamp)) {
        return m.calendar()
      } else {
        return m.format(this.$dateformat()) + '\n ' + m.format(this.$timeformat())
      }
    }
  }

  protected getCost(reservation: ReservationResponse) {
    return reservation.cost && reservation.status === 'CHARGED' ? `${this.$currency(reservation.cost as any)}` : '--'
  }

  protected get primaryColor() {
    return VuetifyColorHelper.color('primary')
  }

  protected get isLate() {
    // TODO: make this work
    return false
  }

  protected get standardColor() {
    return this.isLate ? VuetifyColorHelper.color('error') : VuetifyColorHelper.color('success')
  }

  protected get vehicleTypeColor() {
    const vs = this.reservation.vehicle_slot
    const key = `${vs.reservation_type}${vs.vehicle.category.type}`.toUpperCase()
    return key || 'secondary'
  }
}
